export enum ModifierResponseType {
  MODIFIED,
  UNMODIFIED
}

export class ModifierResponse<T> {
  validatorType: ModifierResponseType;
  result: T;

  constructor(validatorType: ModifierResponseType, result: T) {
    this.result = result;
    this.validatorType = validatorType;
  }

  isModified() {
    return this.validatorType === ModifierResponseType.MODIFIED;
  }

  isUnmodified() {
    return this.validatorType === ModifierResponseType.UNMODIFIED;
  }
}
